var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "people-picker" }, [
    _vm.$slots.breadcrumbs
      ? _c(
          "div",
          { staticClass: "people-picker__breadcrumbs" },
          [_vm._t("breadcrumbs")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.$slots.header
      ? _c(
          "div",
          { staticClass: "people-picker__header" },
          [_vm._t("header")],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c("form", { staticClass: "people-picker__filters" }, [
      _c("div", { staticClass: "people-picker__filters__search" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.query,
              expression: "query"
            }
          ],
          staticClass: "people-picker__filters__search__input input-text",
          attrs: {
            autocomplete: "off",
            placeholder: "Search",
            type: "text",
            id: "edit-search",
            name: "search",
            size: "60",
            maxlength: "128"
          },
          domProps: { value: _vm.query },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.query = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "people-picker__filters__search__submit" },
          [
            _c("span", { staticClass: "sr-only" }, [_vm._v("Search")]),
            _vm._v(" "),
            _c(
              "svg",
              {
                attrs: {
                  width: "1664px",
                  height: "1664px",
                  viewBox: "0 0 1664 1664",
                  version: "1.1",
                  xmlns: "http://www.w3.org/2000/svg",
                  "xmlns:xlink": "http://www.w3.org/1999/xlink"
                }
              },
              [
                _c(
                  "g",
                  {
                    attrs: {
                      id: "Page-1",
                      stroke: "none",
                      "stroke-width": "1",
                      fill: "none",
                      "fill-rule": "evenodd"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M1152,704 C1152,580.666667 1108.16667,475.166667 1020.5,387.5 C932.833333,299.833333 827.333333,256 704,256 C580.666667,256 475.166667,299.833333 387.5,387.5 C299.833333,475.166667 256,580.666667 256,704 C256,827.333333 299.833333,932.833333 387.5,1020.5 C475.166667,1108.16667 580.666667,1152 704,1152 C827.333333,1152 932.833333,1108.16667 1020.5,1020.5 C1108.16667,932.833333 1152,827.333333 1152,704 Z M1664,1536 C1664,1570.66667 1651.33333,1600.66667 1626,1626 C1600.66667,1651.33333 1570.66667,1664 1536,1664 C1500,1664 1470,1651.33333 1446,1626 L1103,1284 C983.666667,1366.66667 850.666667,1408 704,1408 C608.666667,1408 517.5,1389.5 430.5,1352.5 C343.5,1315.5 268.5,1265.5 205.5,1202.5 C142.5,1139.5 92.5,1064.5 55.5,977.5 C18.5,890.5 0,799.333333 0,704 C0,608.666667 18.5,517.5 55.5,430.5 C92.5,343.5 142.5,268.5 205.5,205.5 C268.5,142.5 343.5,92.5 430.5,55.5 C517.5,18.5 608.666667,0 704,0 C799.333333,0 890.5,18.5 977.5,55.5 C1064.5,92.5 1139.5,142.5 1202.5,205.5 C1265.5,268.5 1315.5,343.5 1352.5,430.5 C1389.5,517.5 1408,608.666667 1408,704 C1408,850.666667 1366.66667,983.666667 1284,1103 L1627,1446 C1651.66667,1470.66667 1664,1500.66667 1664,1536 Z",
                        id: "icon-search",
                        fill: "#000000",
                        "fill-rule": "nonzero"
                      }
                    })
                  ]
                )
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "people-picker__filters__orderby" }, [
        _c(
          "label",
          {
            staticClass: "people-picker__filters__orderby__label",
            attrs: { for: "orderby" }
          },
          [_vm._v("Sort by")]
        ),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.sortBy,
                expression: "sortBy"
              }
            ],
            staticClass: "people-picker__filters__orderby__input input-select",
            attrs: { id: "orderby", name: "sort_by" },
            on: {
              change: function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.sortBy = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              }
            }
          },
          [
            _c("option", { attrs: { value: "last-name" } }, [
              _vm._v("Last name")
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "first-name" } }, [
              _vm._v("First name")
            ]),
            _vm._v(" "),
            _c("option", { attrs: { value: "group" } }, [_vm._v("Group")])
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "people-picker__body" }, [
      _c(
        "table",
        { staticClass: "embl-table embl-table--highlight-rows-on-hover" },
        [
          _vm._m(0),
          _vm._v(" "),
          _vm._l(_vm.postsVisible, function(post) {
            return _c("tr", { key: post.id, staticClass: "embl-table__row" }, [
              _c(
                "td",
                { staticClass: "embl-table__row__name" },
                [
                  post.listing_image_thumb
                    ? _c("lazy-image", {
                        attrs: {
                          alt: post.title,
                          href: post.permalink,
                          src: post.listing_image_thumb
                        }
                      })
                    : _c("lazy-image", {
                        attrs: {
                          alt: post.title,
                          href: post.permalink,
                          src: _vm.placeholderProfileImage
                        }
                      }),
                  _vm._v(" "),
                  _c("a", {
                    staticClass: "hidden-sm-down",
                    attrs: { href: post.permalink },
                    domProps: { innerHTML: _vm._s(post.title) }
                  }),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass: "embl-table__row__name__info visible-sm-down"
                    },
                    [
                      _c("a", {
                        staticClass: "visible-sm-down",
                        attrs: { href: post.permalink },
                        domProps: { innerHTML: _vm._s(post.title) }
                      }),
                      _vm._v(" "),
                      post.job_title.length
                        ? _c("span", {
                            domProps: { innerHTML: _vm._s(post.job_title) }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      post.group ? _c("br") : _vm._e(),
                      _vm._v(" "),
                      post.group
                        ? _c("span", {
                            domProps: { innerHTML: _vm._s(post.group) }
                          })
                        : _vm._e()
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "td",
                { staticClass: "embl-table__row__position hidden-sm-down" },
                [
                  _c("span", {
                    staticClass: "embl-table__row__position__label",
                    domProps: { innerHTML: _vm._s(post.job_title) }
                  }),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "embl-table__row__position__read-more",
                      attrs: { href: post.permalink }
                    },
                    [
                      _c("span", [_vm._v("View profile")]),
                      _vm._v(" "),
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "496px",
                            height: "496px",
                            viewBox: "0 0 496 496",
                            version: "1.1",
                            xmlns: "http://www.w3.org/2000/svg",
                            "xmlns:xlink": "http://www.w3.org/1999/xlink"
                          }
                        },
                        [
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "Page-1",
                                stroke: "none",
                                "stroke-width": "1",
                                fill: "none",
                                "fill-rule": "evenodd"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d:
                                    "M248,0 C385,0 496,111 496,248 C496,385 385,496 248,496 C111,496 0,385 0,248 C0,111 111,0 248,0 Z M361.9,231 L226.4,95.5 C217,86.1 201.8,86.1 192.5,95.5 L175.5,112.5 C166.1,121.9 166.1,137.1 175.5,146.4 L277.1,248 L175.5,349.6 C166.1,359 166.1,374.2 175.5,383.5 L192.5,400.5 C201.9,409.9 217.1,409.9 226.4,400.5 L361.9,265 C371.3,255.6 371.3,240.4 361.9,231 Z",
                                  id: "icon-cheron-right-circled",
                                  fill: "#000000",
                                  "fill-rule": "nonzero"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("td", {
                staticClass: "hidden-sm-down hide-on-hover",
                domProps: { innerHTML: _vm._s(post.group) }
              }),
              _vm._v(" "),
              _c("td", { staticClass: "hidden-sm-down" }, [
                post.phone_link && post.phone_link.length
                  ? _c("a", { attrs: { href: post.phone_link } }, [
                      _vm._v(_vm._s(post.phone))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("td", [
                _c("ul", { staticClass: "contact-links" }, [
                  post.email && post.email.length
                    ? _c("li", [
                        _c("a", { attrs: { href: "mailto:" + post.email } }, [
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v(_vm._s(post.email))
                          ]),
                          _vm._v(" "),
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "512px",
                                height: "384px",
                                viewBox: "0 0 512 384",
                                version: "1.1",
                                xmlns: "http://www.w3.org/2000/svg",
                                "xmlns:xlink": "http://www.w3.org/1999/xlink"
                              }
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    id: "Page-1",
                                    stroke: "none",
                                    "stroke-width": "1",
                                    fill: "none",
                                    "fill-rule": "evenodd"
                                  }
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d:
                                        "M464,0 L48,0 C21.49,0 0,21.49 0,48 L0,336 C0,362.51 21.49,384 48,384 L464,384 C490.51,384 512,362.51 512,336 L512,48 C512,21.49 490.51,0 464,0 Z M464,48 L464,88.805 C441.578,107.064 405.832,135.456 329.413,195.295 C312.572,208.542 279.212,240.367 256,239.996 C232.792,240.371 199.421,208.537 182.587,195.295 C106.18,135.465 70.425,107.067 48,88.805 L48,48 L464,48 Z M48,336 L48,150.398 C70.914,168.649 103.409,194.26 152.938,233.044 C174.795,250.249 213.072,288.23 256,287.999 C298.717,288.23 336.509,250.8 359.053,233.052 C408.581,194.269 441.085,168.651 464,150.398 L464,336 L48,336 Z",
                                      id: "icon-envelope",
                                      fill: "#000000",
                                      "fill-rule": "nonzero"
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  post.twitter && post.twitter.length
                    ? _c("li", [
                        _c(
                          "a",
                          {
                            attrs: {
                              target: "_blank",
                              href: "https://twitter.com/" + post.twitter
                            }
                          },
                          [
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v(_vm._s("@" + post.twitter))
                            ]),
                            _vm._v(" "),
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "512px",
                                  height: "416px",
                                  viewBox: "0 0 512 416",
                                  version: "1.1",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  "xmlns:xlink": "http://www.w3.org/1999/xlink"
                                }
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    attrs: {
                                      id: "Page-1",
                                      stroke: "none",
                                      "stroke-width": "1",
                                      fill: "none",
                                      "fill-rule": "evenodd"
                                    }
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d:
                                          "M459.37,103.634 C459.695,108.182 459.695,112.731 459.695,117.279 C459.695,255.999 354.112,415.837 161.137,415.837 C101.685,415.837 46.457,398.618 0,368.731 C8.447,369.705 16.568,370.03 25.34,370.03 C74.395,370.03 119.553,353.462 155.614,325.198 C109.482,324.223 70.822,294.01 57.502,252.426 C64,253.4 70.497,254.05 77.32,254.05 C86.741,254.05 96.163,252.75 104.934,250.477 C56.853,240.73 20.791,198.497 20.791,147.492 L20.791,146.193 C34.76,153.99 51.005,158.863 68.222,159.512 C39.958,140.669 21.441,108.507 21.441,72.121 C21.441,52.629 26.638,34.761 35.735,19.167 C87.39,82.842 165.035,124.425 252.1,128.974 C250.476,121.177 249.501,113.056 249.501,104.934 C249.501,47.106 296.283,0 354.435,0 C384.648,0 411.937,12.67 431.105,33.137 C454.82,28.589 477.561,19.817 497.704,7.797 C489.906,32.163 473.338,52.63 451.572,65.624 C472.689,63.351 493.156,57.502 511.998,49.381 C497.706,70.172 479.837,88.689 459.37,103.634 Z",
                                        id: "icon-twitter",
                                        fill: "#000000",
                                        "fill-rule": "nonzero"
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ])
              ])
            ])
          })
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "people-picker__footer" }, [
      _c("div", { staticClass: "people-picker__footer__back" }, [
        _vm.backLink.length
          ? _c(
              "a",
              { staticClass: "back-link", attrs: { href: _vm.backLink } },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "496px",
                      height: "496px",
                      viewBox: "0 0 496 496",
                      version: "1.1",
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink"
                    }
                  },
                  [
                    _c(
                      "g",
                      {
                        attrs: {
                          id: "Page-1",
                          stroke: "none",
                          "stroke-width": "1",
                          fill: "none",
                          "fill-rule": "evenodd"
                        }
                      },
                      [
                        _c("path", {
                          attrs: {
                            d:
                              "M248,0 C385,0 496,111 496,248 C496,385 385,496 248,496 C111,496 0,385 0,248 C0,111 111,0 248,0 Z M361.9,231 L226.4,95.5 C217,86.1 201.8,86.1 192.5,95.5 L175.5,112.5 C166.1,121.9 166.1,137.1 175.5,146.4 L277.1,248 L175.5,349.6 C166.1,359 166.1,374.2 175.5,383.5 L192.5,400.5 C201.9,409.9 217.1,409.9 226.4,400.5 L361.9,265 C371.3,255.6 371.3,240.4 361.9,231 Z",
                            id: "icon-cheron-left-circled",
                            fill: "#000000",
                            "fill-rule": "nonzero",
                            transform:
                              "translate(248.000000, 248.000000) scale(-1, 1) translate(-248.000000, -248.000000) "
                          }
                        })
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.backLinkLabel) }
                })
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "people-picker__footer__pagination" }, [
        _vm.totalPages > 1
          ? _c(
              "div",
              { staticClass: "pagination" },
              [
                _c(
                  "button",
                  {
                    staticClass: "prev page-numbers",
                    class: { disabled: _vm.page <= 1 },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.loadPreviousPage()
                      }
                    }
                  },
                  [_vm._v("« Previous")]
                ),
                _vm._v(" "),
                _vm._l(_vm.paginationRange, function(pageNumber) {
                  return _c(
                    "button",
                    {
                      key: pageNumber,
                      staticClass: "page-numbers",
                      class: {
                        current: _vm.page === pageNumber,
                        dots: pageNumber === "..."
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.goToPage(pageNumber)
                        }
                      }
                    },
                    [_vm._v(_vm._s(pageNumber))]
                  )
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "next page-numbers",
                    class: { disabled: _vm.page >= _vm.totalPages },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.loadNextPage()
                      }
                    }
                  },
                  [_vm._v("Next »")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "next page-numbers",
                    class: { disabled: _vm.page >= _vm.totalPages },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.loadLastPage()
                      }
                    }
                  },
                  [_vm._v("Last »")]
                )
              ],
              2
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "embl-table__header-row hidden-sm-down" }, [
      _c("th", { attrs: { scope: "col" } }, [_vm._v("Name")]),
      _vm._v(" "),
      _c("th", { staticClass: "hidden-sm-down", attrs: { scope: "col" } }, [
        _vm._v("Position")
      ]),
      _vm._v(" "),
      _c("th", { staticClass: "hidden-sm-down", attrs: { scope: "col" } }, [
        _vm._v("Group")
      ]),
      _vm._v(" "),
      _c("th", { staticClass: "hidden-sm-down", attrs: { scope: "col" } }, [
        _vm._v("Phone")
      ]),
      _vm._v(" "),
      _c("th", { attrs: { scope: "col" } }, [_vm._v("Connect")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/omer/Projects/Arcadian/embl/wp-content/themes/embl/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/omer/Projects/Arcadian/embl/wp-content/themes/embl/node_modules/vue-loader/lib?{}!./scripts/vue/PeoplePicker.vue?vue&type=template&id=166d279e&
// module id = 90
// module chunks = 0